module.exports = __webpack_public_path__ + "img/pdf_2x.ec217391.svg";